/* FRATERNAL — frt-cart.js. Added 2026-10-27 (Jalen).

   Drives three things, all of which work WITHOUT this file:
     1. the slide-in bag drawer (no JS -> the bag link is a plain link to /cart)
     2. the -/+ steppers and REMOVE on /cart and in the drawer
        (no JS -> `updates[]` + the noscript UPDATE button, and REMOVE is a real GET
         to /cart/change)
     3. add-to-bag on a PDP opening the drawer instead of navigating away
        (no JS -> the product form POSTs to /cart as it always did)

   Cart state is addressed by line KEY, never by index: Shopify SPLITS a line when a
   discount covers some units and not others, so indexes move under you mid-session —
   which is exactly what the ad-only 3-for-$100 does to this store's carts.

   Markup comes back from the Section Rendering API in the SAME round trip as the
   mutation, so there is no add.js-then-cart.js second hop. */
(function () {
  var d = document;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DRAWER_SECTION = 'frt-cart-drawer';
  var HEADER_SECTION = 'frt-header';
  var scrollY = 0;
  var lastOpener = null;

  function $(sel, ctx) { return (ctx || d).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }
  function drawer() { return $('[data-frt-drawer]'); }

  /* ------------------------------------------------------------------ open/close */
  function lock() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    d.body.style.top = (-scrollY) + 'px';
    d.body.classList.add('frt-locked');
  }
  function unlock() {
    if (!d.body.classList.contains('frt-locked')) return;
    d.body.classList.remove('frt-locked');
    d.body.style.top = '';
    window.scrollTo(0, scrollY);   // position:fixed alone drops the page back to the top
  }

  function open(opener) {
    var dr = drawer();
    if (!dr) return false;
    lastOpener = opener || null;
    dr.classList.add('is-open');
    dr.setAttribute('aria-hidden', 'false');
    lock();
    var focusTarget = $('[data-frt-drawer-close].cdraw__x', dr);
    if (focusTarget) focusTarget.focus();
    return true;
  }

  function close() {
    var dr = drawer();
    if (!dr || !dr.classList.contains('is-open')) return;
    dr.classList.remove('is-open');
    dr.setAttribute('aria-hidden', 'true');
    unlock();
    if (lastOpener && d.contains(lastOpener)) lastOpener.focus();
    lastOpener = null;
  }

  function isOpen() { var dr = drawer(); return !!dr && dr.classList.contains('is-open'); }

  /* --------------------------------------------------------------- section paint */
  function sectionList() {
    var ids = [HEADER_SECTION];
    if (drawer()) ids.push(DRAWER_SECTION);
    var page = $('[data-frt-cart-page]');
    if (page && page.dataset.frtSection) ids.push(page.dataset.frtSection);
    return ids.join(',');
  }

  // Swap one element's innerHTML for the matching element inside returned markup.
  function swap(markup, selector, into) {
    if (!markup || !into) return;
    var parsed = new DOMParser().parseFromString(markup, 'text/html');
    var fresh = parsed.querySelector(selector);
    if (fresh) into.innerHTML = fresh.innerHTML;
  }

  function paint(sections) {
    if (!sections) return;

    var dr = drawer();
    if (dr && sections[DRAWER_SECTION]) {
      var wasOpen = dr.classList.contains('is-open');
      var parsed = new DOMParser().parseFromString(sections[DRAWER_SECTION], 'text/html');
      var fresh = parsed.querySelector('[data-frt-drawer] .cdraw__panel');
      var panel = $('.cdraw__panel', dr);
      if (fresh && panel) panel.innerHTML = fresh.innerHTML;
      if (wasOpen) { dr.classList.add('is-open'); dr.setAttribute('aria-hidden', 'false'); }
    }

    var page = $('[data-frt-cart-page]');
    if (page && page.dataset.frtSection && sections[page.dataset.frtSection]) {
      swap(sections[page.dataset.frtSection], '.js-frt-cart-contents',
           $('.js-frt-cart-contents', page));
    }

    if (sections[HEADER_SECTION]) {
      var m = sections[HEADER_SECTION].match(/class="bag__n"[^>]*>(\d+)</);
      if (m) setBag(Number(m[1]));
    }
  }

  function setBag(n) { $$('.bag__n').forEach(function (el) { el.textContent = n; }); }

  /* ------------------------------------------------------------------- mutations */
  function busy(line, on) { if (line) line.classList.toggle('is-busy', !!on); }

  function lineError(line, msg) {
    var slot = line && $('[data-frt-line-err]', line);
    if (slot) slot.textContent = msg || '';
  }

  function change(key, quantity, line) {
    busy(line, true);
    lineError(line, '');
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: sectionList(),
                             sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        // Clear busy BEFORE the paint that consumes it. Clearing after leaves a row
        // greyed out and pointer-events:none with nothing scheduled to undo it.
        busy(line, false);
        if (!res.ok) {
          lineError(line, (res.body && res.body.description) || 'Could not update that line.');
          return null;
        }
        paint(res.body.sections);
        return res.body;
      })
      .catch(function () {
        busy(line, false);
        lineError(line, 'Could not update that line. Try again.');
        return null;
      });
  }

  /* ----------------------------------------------------------------- add to bag */
  function addFromForm(form) {
    var fd = new FormData(form);
    fd.append('sections', sectionList());
    fd.append('sections_url', window.location.pathname);
    // A "Complete the set" form is empty: its size radios and button sit elsewhere and
    // join it through the `form` attribute, so look in form.elements, not just inside it.
    var btn = form.querySelector('[name="add"], button[type="submit"]') ||
              Array.prototype.find.call(form.elements, function (el) { return el.type === 'submit'; });
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (btn) btn.removeAttribute('aria-busy');
        if (!res.ok) { form.submit(); return; }   // let Shopify render its own error page
        paint(res.body.sections);
        open(btn);
      })
      .catch(function () { if (btn) btn.removeAttribute('aria-busy'); form.submit(); });
  }

  /* --------------------------------------------------------------------- events */
  d.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-frt-cart-open]');
    if (openBtn && drawer()) { e.preventDefault(); open(openBtn); return; }

    if (e.target.closest('[data-frt-drawer-close]')) { e.preventDefault(); close(); return; }

    var step = e.target.closest('[data-frt-step]');
    if (step) {
      e.preventDefault();
      var line = step.closest('[data-frt-line]');
      var input = $('[data-frt-qty-input]', step.closest('[data-frt-qty]'));
      var next = Math.max(0, Number(input.value || 0) + Number(step.dataset.frtStep));
      input.value = next;
      change(line.dataset.frtKey, next, line);
      return;
    }

    var rm = e.target.closest('[data-frt-remove]');
    if (rm) {
      e.preventDefault();
      var rline = rm.closest('[data-frt-line]');
      change(rline.dataset.frtKey, 0, rline);
      return;
    }
  });

  // Typing straight into the number field, committed on blur / Enter.
  d.addEventListener('change', function (e) {
    // "Complete the set" size picked: the button reads SELECT SIZE until one is.
    var setSize = e.target.closest('[data-frt-set-size]');
    if (setSize) {
      var setBtn = $('[data-frt-set-add]', setSize.closest('[data-frt-set]'));
      if (setBtn) setBtn.textContent = setBtn.dataset.label;
      return;
    }
    var input = e.target.closest('[data-frt-qty-input]');
    if (!input) return;
    var line = input.closest('[data-frt-line]');
    if (!line) return;
    var n = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = n;
    change(line.dataset.frtKey, n, line);
  });

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab' || !isOpen()) return;
    // Keep focus inside the panel while it is modal.
    var panel = $('.cdraw__panel', drawer());
    var f = $$('a[href],button:not([disabled]),input,select,textarea', panel)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  d.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    if (form.matches('[data-frt-qa-form]')) return;   // quick-add owns its own submit
    // /cart has no drawer, so its forms post normally, except the set cards, which add
    // and repaint the page in place (open() is a no-op there: no drawer to open).
    if (!drawer() && !form.matches('[data-frt-set-form]')) return;
    e.preventDefault();
    addFromForm(form);
  });

  /* A drawer left open when the shopper navigated to checkout comes BACK open, with a
     stale body lock, when they hit Back — BFCache restores the JS heap and the DOM. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    $$('.is-busy').forEach(function (el) { el.classList.remove('is-busy'); });
    close();
    unlock();
  });

  window.frtCart = { open: open, close: close, paint: paint, setBag: setBag };
})();
